
import { mapState } from "vuex";

export default {
    data() {
        return {
            insightsBaseUrl: process.env.VUE_APP_NONFICTION_BASE_API_URL
        }
    },
    computed: {
        ...mapState({
            accessTypeIds: state => state.AccessTypes.idList
        })
    },
    methods: {
        $_getExampleBookInsights(bookInsightIds = []) {
            this.$store.dispatch("Application/showLoader", true);

            axiosCms({
                url: `${this.insightsBaseUrl}/site/book-insights?q=(access_type:${this.accessTypeIds.FREE},id:${bookInsightIds.join("|")})`,
                method: "GET"
            }).then(({ data: bookInsights }) => {
                if (bookInsights.length) {
                    this.$_sortBookInsights(bookInsights);
                }
            }).finally(() => {
                this.$store.dispatch("Application/showLoader", false);
            });
        },
        $_sortBookInsights(insightsList) {
            this.harcodedBookInsigthIds.forEach((bookInsightId) => {
                const bookInsight = insightsList.find((insight) => {
                    return insight.id == bookInsightId;
                });

                if (!bookInsight) {
                    return;
                }

                this.bookInsights.push(bookInsight);
            });
        }
    }
}
